import styled from "styled-components";

import { Divider } from "ds/Accordion";
import { AddButton } from "ds/Button";
import TextareaDs from "ds/Textarea";

export const RadioGroupWrapper = styled.div`
  [role="radiogroup"] {
    flex-wrap: wrap;
  }

  .radio-label {
    display: inline-block;
    margin-bottom: 8px;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  svg {
    width: 32px;
    height: 24px;
  }
  color: var(--section-ebony-light-color, var(--ebony-light));

  &:hover,
  &:active {
    cursor: pointer;
    color: var(--button-color-primary-600-color, var(--color-primary-600));
    border: none;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--button-granite-color, var(--granite));
`;

export const KeyValueTitle = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: var(--section-ebony-light-color, var(--ebony-light));
`;

export const KeyValuePair = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: 700px) {
    flex-wrap: wrap;
  }

  margin-bottom: 16px;
  input {
    width: 100%;
  }
`;

export const Separator = styled(Divider)`
  margin: 24px 0;
`;

export const AddItemButton = styled(AddButton)`
  color: var(--section-color-primary-600-color, var(--color-primary-600));
`;

export const Textarea = styled(TextareaDs)`
  margin-bottom: 16px;
`;
